import { render, staticRenderFns } from "./DisciplineBreakdownChart.vue?vue&type=template&id=f296825e&scoped=true&"
import script from "./DisciplineBreakdownChart.vue?vue&type=script&lang=js&"
export * from "./DisciplineBreakdownChart.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineBreakdownChart.vue?vue&type=style&index=0&id=f296825e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f296825e",
  null
  
)

export default component.exports